// Crash/refresh recovery for the cashier: the logged client and the sale in progress.
// Written on every change, read once on mount, cleared on logout.

const KEY = 'salesSnapshot';
const VERSION = 1;

// A snapshot older than this is not the same sale any more, whatever the storage says
const MAX_AGE_MS = 8 * 60 * 60 * 1000;

export function writeSnapshot(snapshot) {
  try {
    window.localStorage.setItem(
      KEY,
      JSON.stringify({ ...snapshot, version: VERSION, savedAt: Date.now() })
    );
  } catch (err) {
    // Quota or private mode: recovery is a safety net, never a blocker
    console.error('salesSnapshot - could not save:', err);
  }
}

export function clearSnapshot() {
  try {
    window.localStorage.removeItem(KEY);
  } catch (err) {
    console.error('salesSnapshot - could not clear:', err);
  }
}

export function readSnapshot() {
  let raw = null;

  try {
    raw = window.localStorage.getItem(KEY);
  } catch (err) {
    console.error('salesSnapshot - could not read:', err);
    return null;
  }

  if (!raw) {
    return null;
  }

  let snapshot = null;

  try {
    snapshot = JSON.parse(raw);
  } catch (err) {
    console.error('salesSnapshot - corrupt, discarded:', err);
    clearSnapshot();
    return null;
  }

  if (!snapshot || snapshot.version !== VERSION || !snapshot.savedAt) {
    clearSnapshot();
    return null;
  }

  if (Date.now() - snapshot.savedAt > MAX_AGE_MS) {
    clearSnapshot();
    return null;
  }

  if (!snapshot.user || !snapshot.sale) {
    clearSnapshot();
    return null;
  }

  return snapshot;
}
